import { FC } from "react";

import {
    InsightsIndividual,
    InsightsTeam,
} from "store/api/investorCompany/interfaces";
import InsightStatus from "../InsightStatus";
import { GaugeChart } from "components/ui/GaugeChart";
import Title from "routes/company/components/Modal/Title";
import IndividualScores from "routes/company/components/IndividualScores";
import InsightDescription from "routes/company/components/Modal/InsightDescription";

type Props = {
    tooltip: string;
    teamData: InsightsTeam;
    individualData: InsightsIndividual;
};

const OverallModal: FC<Props> = ({
    tooltip,
    individualData,
    teamData: { td_overall },
}) => {
    const tdOverallValue = (td_overall?.value as number) ?? 0;

    return (
        <div className="flex flex-col gap-4">
            <Title tooltip={tooltip}>Overall score</Title>

            <div className="flex justify-center">
                <GaugeChart value={tdOverallValue} />
            </div>

            <div>
                <InsightStatus value={tdOverallValue} />

                <InsightDescription>
                    {td_overall?.conclusion?.text ?? ""}
                </InsightDescription>
            </div>

            <IndividualScores
                individualData={individualData}
                teamMetricValue={tdOverallValue}
                metric="td_overall"
            />
        </div>
    );
};

export default OverallModal;
